<script>
  import formatDate from '@utils/format-date'
  import setWindowHistory from "@utils/window-history";

  export default {
    props: {
      value: {
        type: Object,
        default: () => {
          return {}
        }
      },
      loading: {
        type: Boolean,
        default: false
      },
      list: {
        type: Array,
        default: () => {
          return [
            {
              width: '20%',                 // [%, px, rem, em, vw, vh]
              type: 'text',                 // 必填 [text, select, mouth, submit]
              placeholder: 'placeholder',
              name: 'name',                 // 必填
              options: [                    // select: 必填 | [text, mouth, submit]: 非必填
                {
                  text: 'text',
                  value: 'value',
                }
              ],
            }
          ]
        }
      },
      submitText: {
        type: String,
        default: '搜尋'
      },
      isShowFilter: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        scrollTop: 0,
        baseSearchTop: 0,
        baseSearchHeight: 0,
        vw: 0,
        baseSearchBarHieght: 0,
      }
    },
    computed: {
      submitData: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
      isMenuFixed() {
        return this.scrollTop > this.baseSearchTop;
      },
      buttonBarList() {
        return [
          {
            text: '確定',
            class: 'flex-grow-1',
            buttonClass: 'isStylePrimary isRadius isSmall isFull',
            onClick: () => {
              this.onSubmit()
              this.isCloseFilter()
            },
          },
          {
            text: '取消',
            class: 'flex-grow-1',
            buttonClass: 'isStyleDark isOutline2 isRadius isSmall isFull',
            onClick: () => {
              this.isCloseFilter()
            },
          },
        ]
      },
      heightStyle() {
        if(this.$globalIsMobileDevice) {
          return `height:${this.baseSearchBarHieght + 160}px`
        } else {
          return false
        }
      }
    },
    watch: {
      isShowFilter: function(newValue, oldValue) {
        if (newValue) {
          document.querySelector('input').focus()
          document.body.style.overflow = "hidden";
          this.setData()
        }else {
          document.body.removeAttribute("style")
        }
      }
    },
    mounted() {
      // const baseSearchTop = () => {
      //   const member = [
      //     'member-event-list',
      //     'member-activity-list',
      //   ];
      //   const parentTop = () => {
      //     return member.includes(this.$route.name)
      //       ? this.$refs.baseSearchBar.offsetParent.offsetTop
      //       : 0;
      //   };
      //   this.baseSearchTop = this.$refs.baseSearchBar.offsetTop + parentTop();
      // };
      const initScrollListener = () => {
        window.addEventListener('scroll', this.onScroll);
      }
      const initResizeListener = () => {
        window.addEventListener('resize', this.setData);
      };
      initResizeListener();
      initScrollListener();
      // baseSearchTop();
      setTimeout(() => {
        this.onScroll();
        this.setData()
      }, 600)
    },
    destroyed() {
      const removeScollListener = () => {
        window.removeEventListener('scroll', this.onScroll);
      }
      const removeResizeListener = () => {
        window.removeEventListener('resize', this.setData)
      };
      removeScollListener();
      removeResizeListener();
    },
    methods: {
      formatDate,
      setData() {
        this.vw = window.innerWidth;
        const member = [
          'member-event-list',
          'member-activity-list',
        ];
        const parentTop = () => {
          if(this.vw > 767) {
            return member.includes(this.$route.name)
              ? this.$refs.baseSearchBar.offsetParent.offsetTop
              : 0;
          } else {
            return 0;
          }
        };
        this.$nextTick(() => {
          this.baseSearchTop = this.$refs.baseSearchBar.offsetTop + parentTop();
          this.baseSearchBarHieght = document.querySelector('.baseSearchBar__list').clientHeight
        })
        
      },
      onSubmit() {
        const query = () => {
          const query = {};

          Object.keys(this.submitData)
            .forEach(key => {
              query[key] = this.submitData[key] || undefined
            });

          return query;
        };

        setWindowHistory({
          query: {
            ...this.$route.query,
            ...query()
          }
        });
        this.$emit('search', this.submitData)
      },
      onScroll() {
        this.scrollTop = this.getWindowScrollTop();
      },
      getWindowScrollTop() {
        let windowScrollTop = 0;
        if(typeof window.pageYOffset !== 'undefined') {
          windowScrollTop = window.pageYOffset;
        } else if(typeof document.compatMode !== 'undefined' && document.compatMode !== 'BackCompat') {
          windowScrollTop = document.documentElement.scrollTop;
        } else if(typeof document.body !== 'undefined') {
          windowScrollTop = document.body.scrollTop;
        }
        return windowScrollTop;
      },
      isCloseFilter() {
        this.$emit('openFilter')
      },
      filterTitle(name) {
        const filterNameMap = {
          'brand': '品牌',
          'month': '時間',
          'query': '搜尋',
          'fileCategory': '檔案類別',
          'industryCategory': '產業類別',
          'category': '分類',
          'type': '類型',
          'city': '縣市',
        }
        return filterNameMap[name]
      },
    }
  }
</script>
<template>
  <div 
    ref="baseSearchBar" 
    :class="[$style.baseSearchBarBox, { 'isShow': isShowFilter }]">
    <div class="d-md-none d-block">
      <BaseButton
        class="isText d-flex ml-auto mb-4"
        @click="isCloseFilter"
      >
        <i style="font-size: 18px;" class="icomoon icon-cross"></i>
      </BaseButton>
      <h4>篩選</h4>
      <el-divider></el-divider>
    </div>
    <form
      :class="[$style.baseSearchBar,{ isFixed: isMenuFixed }]"
      @submit.prevent="onSubmit"
    >
      <div 
        class="baseSearchBar__box"
        :style="heightStyle"
      >
        <div class="baseSearchBar__list">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="baseSearchBar__list__item"
            :style="{ 'max-width': item.width }"
          >
            <div class="baseSearchBar__title d-md-none my-3">
              <div class="font-medium text-lg">{{filterTitle(item.name)}}</div>
            </div>
            <template v-if="item.type === 'select'">
              <el-select
                v-model="submitData[item.name]"
                :placeholder="item.placeholder"
                popper-class="isStyleSearchBar"
                class="isStyleSearchBar"
                clearable
              >
                <el-option
                  v-for="(option, index) in (item.options || [])"
                  :key="index"
                  :value="option.value"
                  :label="option.text"
                >
                  {{ option.text }}
                </el-option>
              </el-select>
            </template>
            <template v-if="item.type === 'text'">
              <el-input
                v-model="submitData[item.name]"
                class="isStyleSearchBar"
                :placeholder="item.placeholder"
                clearable
              ></el-input>
            </template>
            <template v-if="item.type === 'month'">
              <el-date-picker
                v-model="submitData[item.name]"
                type="month"
                class="isStyleSearchBar"
                :placeholder="item.placeholder"
                format='yyyy年MM月'
                :value-format=" item.valueFormat || 'yyyy/MM'"
                popper-class="isStyleSearchBar"
                :editable="false"
              >
              </el-date-picker>
            </template>
          </div>
          <div class="baseSearchBar__list__item baseSearchBar__list__item__btn " style="max-width: max-content;">
            <BaseButton
              type="submit"
              class="isStylePrimary isFull d-md-block d-none"
              :loading="loading"
            >
              {{ submitText }}
            </BaseButton>
            <BaseButtonBar
              :button-list="buttonBarList"
              is-show
              class="d-md-none"
            />
          </div>
        </div>
      </div>
      <!-- <div class="d-block d-lg-none mb-5" style="padding: 1rem 0.5rem;background:  #F5F5F5;">
        <template v-for="(item, index) in list">
          <template v-if="item.type === 'select'">
            <el-select
              :key="index"
              v-model="submitData[item.name]"
              :placeholder="item.placeholder"
              class="isStyleMenu mb-3 mb-lg-5"
              clearable
            >
              <el-option
                v-for="(option, index) in (item.options || [])"
                :key="option.value"
                :value="option.value"
                :label="option.text"
              >
                {{ option.text }}
              </el-option>
            </el-select>
          </template>
          <template v-if="item.type === 'text'">
            <el-input
              :key="index"
              v-model="submitData[item.name]"
              class="isStyleMenu mb-3 mb-lg-5"
              :placeholder="item.placeholder"
              clearable
            ></el-input>
          </template>
          <template v-if="item.type === 'mouth'">
            <el-date-picker
              :key="index"
              v-model="submitData[item.name]"
              type="month"
              class="isStyleMenu mb-3 mb-lg-5"
              :placeholder="item.placeholder"
              value-format="yyyy/MM"
            >
            </el-date-picker>
          </template>
        </template>
        <BaseButton
          type="submit"
          class="isStylePrimary isFull"
          :loading="loading"
        >
          {{ submitText }}
        </BaseButton>
      </div> -->
    </form>
  </div>

</template>
<style lang="scss" module>
  .baseSearchBarBox {
    height: 82px;
    margin-bottom: 6.25rem;

    @include max-lg {
      height: auto;
    }

    @include max-md {
      display: none;
      
    }
    &:global {
      &.isHasBrandMenu {
        .isFixed {
          top: 178px;

          @media screen and (max-width: 1176px) {
            top: 203px;
          }
        }
      }
      &.isShow {
        @include max-md {
          height: calc((var(--vh, 1vh)*100));
          display: block;
          position: fixed;
          left: 0;
          z-index: 2000;
          padding: 17px 19px 0;
          // padding-top: 1rem;
          // padding-right: 15px;
          // padding-bottom: 8rem;
          overflow-y: auto;
          width: 100%;
          top: 0;
          &:before {
            content: '';
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;
            background: hsla(0,0%,100%,.94);
            filter: blur(4px);
            z-index: -1;
          }
        }
      }
    }
  }

  .baseSearchBar {
    position: static;
    top: -300px;
    z-index: 2001;
    transition: .6s;

    &:global {
      &.isFixed {
        position: fixed;
        top: 113px;
        right: 0;
        left: 0;
        z-index: 1501;

        @include max-lg {
          position: static;
        }

        .baseSearchBar {
          &__box {
            background: rgba(255, 255, 255, 0.95);
            box-shadow: 0 2px 4px rgba(33, 69, 88, 16%);
            backdrop-filter: blur(3px);
            @include max-lg {
              box-shadow: none;
              background: transparent;
              backdrop-filter: none;
            }
          }

          &__list {
            width: 100%;
            max-width: 1340px;
            // padding-left: 19px;
            // padding-right: 19px;
            margin: 0 auto;
            border: 0;

          }
        }
      }
    }

    :global {
      .baseSearchBar {
        &__list {
          display: flex;
          align-items: center;
          height: 82px;
          // overflow: hidden;
          background-color: #FFF;
          border: $color-gray-4 1px solid;
          border-right: 0;

          @include max-lg {
            display: block;
            height: auto;
            padding: 1rem 0.5rem;
            overflow: visible;
            background-color: $color-gray-2;
            border: 0;
          }

          @include max-md {
            background: transparent;
            padding: 0;
            display: flex;
            flex-direction: column;
            // height: calc((var(--vh, 1vh)*100) + 160px);
          }
          &__item {
            position: relative;
            flex: 1;

            &:not(:nth-last-child(1)):not(:nth-last-child(2)) {
              &::after {
                position: absolute;
                top: 22px;
                right: 0;
                width: 3px;
                height: 3px;
                content: "";
                background-color: #E2E4E8;
                border-radius: 50%;
                box-shadow: 0 10px 0 0 #E2E4E8, 0 20px 0 0 #E2E4E8, 0 30px 0 0 #E2E4E8;

                @include max-lg {
                  display: none;
                }
              }
              @include max-md {
                border-bottom: 1px solid #E2E4E8;
                padding-bottom: 1.5rem;
              }
            }

            @include max-lg {
              max-width: 100% !important;
              margin-bottom: 1rem;
              // border: 1px solid $color-gray-3;
            }

            @include max-md {
              width: 100%;
              flex: none;
              margin-bottom: 0;
              &__btn {
                margin-top: auto;
                .baseButton {
                  border-radius: 5px;
                }
              }
            }
          }
          
        }
      }
    }
  }
</style>